import { IsArray, IsEnum, IsNumber, IsOptional, IsString, Max, Min } from 'class-validator';
import {
  PropertyKeyManagement,
  PropertyMandateDuration,
  PropertyMandateType,
  PropertySellerPriority,
} from './property-enums';

export class PropertyMandateDto {
  @IsOptional()
  @IsEnum(PropertyMandateType)
  type?: PropertyMandateType;

  @IsEnum(PropertyMandateDuration)
  duration: PropertyMandateDuration = PropertyMandateDuration.THREE_MONTHS;

  @IsOptional()
  @IsNumber()
  @Min(0.5)
  @Max(15)
  targetCommissionRate?: number;

  @IsOptional()
  @IsArray()
  @IsEnum(PropertyKeyManagement, { each: true })
  keyManagement?: PropertyKeyManagement[];

  @IsArray()
  @IsEnum(PropertySellerPriority, { each: true })
  priorities: PropertySellerPriority[] = [];

  @IsOptional()
  @IsString()
  specialInstructions?: string;
}
